import { lazy } from 'react';

export const OperationsCenterPage = lazy(() => import('./OperationsCenterPage'));
